import React from 'react';
import NoProductImg from './images/NotFound.svg';
import noImg from '../../assets/no-itm.png';
import css from './index.module.scss';
import { FormattedMessage } from 'react-intl';

function SearchNotFoundContainer() {
  return (
    <div className={css.searchEmptyContainer}>
      <img
        src={NoProductImg}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImg;
        }}
        alt="No Products Found"
      />
      <span className={css.line1}>
        <FormattedMessage id="oops_no_products_found" defaultMessage="OOPS, no products found." />
      </span>
      <span className={css.line2}>
        <FormattedMessage
          id="try_again_with_a_new_search_query"
          defaultMessage="Try again with a new search query!"
        />
      </span>
    </div>
  );
}

export default SearchNotFoundContainer;
